/**
 * TODO: Uncomment the disable devtools code block in production mode.
 */

/**
 * AIJS EXPERIMENT PLATFORM
 * ==============================================
 * New Platform to collect user's data and provide
 * AI based recommendations for available jobs.
 * ==============================================
 *
 * @remarks
 * @see @link {https://goodbusinesslab.atlassian.net/wiki/spaces/AE/overview} for documentation of requirements
 * @see @link {https://tsdoc.org/} to understand comments for documentation.
 *
 * @packageDocumentation
 */

import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import { RecoilRoot } from "recoil";
import { BrowserRouter } from "react-router-dom";
// import { disableReactDevTools } from "@fvilers/disable-react-devtools";

// if (process.env.NODE_ENV === "production") {
//   disableReactDevTools();
// }

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Failed to find the root element");
} else {
  const root = ReactDOM.createRoot(container);

  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
    // </React.StrictMode>
  );
}
